<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label for="filterSituacao" class="col-form-label">Situação</label>
                <select class="form-control" name="filterSituacao" id="filterSituacao" 
                    [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null; isFilterDirty = true"
                    #situacao="ngModel">
                    <option value="">Todas as situações</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>                                       
            </div>
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Representantes</label>
                <sgt-representante-multiselect
                    [(idsRepresentantes)]="filter.idsRepresentantes"
                    (idsRepresentantesChange)="onChangeRepresentantes()"
                    [(somenteAtivos)]="filter.somenteRepresentantesAtivos">
                </sgt-representante-multiselect>               
            </div>                                     
        </div>               
    </div>
</div>